const t = {
  "cdr-utility-sans": "cdr-utility-sans_15-0-1"
};
export {
  t as default
};
